// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: aerial_interfaces/msg/FlightMode.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "aerial_interfaces.msg.pb";

export interface FlightMode {
  mode: FlightMode_ModeEnum;
  description: string;
}

export enum FlightMode_ModeEnum {
  MODE_UNKNOWN = 0,
  MODE_DISARMED = 1,
  MODE_ARMED = 2,
  MODE_TAKEOFF = 3,
  MODE_HOVERING = 4,
  MODE_FLYING = 5,
  MODE_MISSION = 6,
  MODE_RTL = 7,
  MODE_LANDING = 8,
  MODE_LANDED = 9,
  UNRECOGNIZED = -1,
}

export function flightMode_ModeEnumFromJSON(object: any): FlightMode_ModeEnum {
  switch (object) {
    case 0:
    case "MODE_UNKNOWN":
      return FlightMode_ModeEnum.MODE_UNKNOWN;
    case 1:
    case "MODE_DISARMED":
      return FlightMode_ModeEnum.MODE_DISARMED;
    case 2:
    case "MODE_ARMED":
      return FlightMode_ModeEnum.MODE_ARMED;
    case 3:
    case "MODE_TAKEOFF":
      return FlightMode_ModeEnum.MODE_TAKEOFF;
    case 4:
    case "MODE_HOVERING":
      return FlightMode_ModeEnum.MODE_HOVERING;
    case 5:
    case "MODE_FLYING":
      return FlightMode_ModeEnum.MODE_FLYING;
    case 6:
    case "MODE_MISSION":
      return FlightMode_ModeEnum.MODE_MISSION;
    case 7:
    case "MODE_RTL":
      return FlightMode_ModeEnum.MODE_RTL;
    case 8:
    case "MODE_LANDING":
      return FlightMode_ModeEnum.MODE_LANDING;
    case 9:
    case "MODE_LANDED":
      return FlightMode_ModeEnum.MODE_LANDED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FlightMode_ModeEnum.UNRECOGNIZED;
  }
}

export function flightMode_ModeEnumToJSON(object: FlightMode_ModeEnum): string {
  switch (object) {
    case FlightMode_ModeEnum.MODE_UNKNOWN:
      return "MODE_UNKNOWN";
    case FlightMode_ModeEnum.MODE_DISARMED:
      return "MODE_DISARMED";
    case FlightMode_ModeEnum.MODE_ARMED:
      return "MODE_ARMED";
    case FlightMode_ModeEnum.MODE_TAKEOFF:
      return "MODE_TAKEOFF";
    case FlightMode_ModeEnum.MODE_HOVERING:
      return "MODE_HOVERING";
    case FlightMode_ModeEnum.MODE_FLYING:
      return "MODE_FLYING";
    case FlightMode_ModeEnum.MODE_MISSION:
      return "MODE_MISSION";
    case FlightMode_ModeEnum.MODE_RTL:
      return "MODE_RTL";
    case FlightMode_ModeEnum.MODE_LANDING:
      return "MODE_LANDING";
    case FlightMode_ModeEnum.MODE_LANDED:
      return "MODE_LANDED";
    case FlightMode_ModeEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseFlightMode(): FlightMode {
  return { mode: 0, description: "" };
}

export const FlightMode: MessageFns<FlightMode> = {
  encode(message: FlightMode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== 0) {
      writer.uint32(3193100736).int32(message.mode);
    }
    if (message.description !== "") {
      writer.uint32(1864531538).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlightMode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlightMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 399137592: {
          if (tag !== 3193100736) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
        case 233066442: {
          if (tag !== 1864531538) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlightMode {
    return {
      mode: isSet(object.mode) ? flightMode_ModeEnumFromJSON(object.mode) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: FlightMode): unknown {
    const obj: any = {};
    if (message.mode !== 0) {
      obj.mode = flightMode_ModeEnumToJSON(message.mode);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FlightMode>, I>>(base?: I): FlightMode {
    return FlightMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FlightMode>, I>>(object: I): FlightMode {
    const message = createBaseFlightMode();
    message.mode = object.mode ?? 0;
    message.description = object.description ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
